import {
  addStartingPointCoords,
  stringifyCoords,
} from '@modules/planner/unit-menu/utils';
import {
  movePOZWorkOrder,
  updateTravelTime,
} from '@modules/work-order/work-order-api';
import { getDrivingInfo } from '@composite/map/utils/get-driving-info';
import { GPSPoint, WorkOrder } from '@models';
import { updateEdgeWorkOrdersTravelTime } from './update-edge-work-order-travel';

export async function moveWorkOrder({
  workOrder,
  newStart,
  nextWorkOrder,
  prevWorkOrder,
  unitStartingPoint,
}: {
  workOrder: WorkOrder;
  newStart: string;
  nextWorkOrder?: WorkOrder;
  prevWorkOrder?: WorkOrder;
  unitStartingPoint: GPSPoint;
}) {
  try {
    const res = await movePOZWorkOrder(workOrder.id, newStart)?.json();
    if (!res) {
      return { ok: false, error: 'Nepodarilo sa posunúť pracovný príkaz.' };
    }

    const movedWorkOrderTravelTime = {
      next: 0,
      previous: 0,
    };

    if (!nextWorkOrder) {
      // moved WO is last, add travel time to starting point

      const woCoords = stringifyCoords([workOrder]);
      const travelNextCoords = addStartingPointCoords(
        woCoords,
        unitStartingPoint,
        'end'
      );
      const travelTime = await getDrivingInfo(travelNextCoords);
      movedWorkOrderTravelTime.next = Math.round(travelTime.duration);
    } else if (nextWorkOrder?.id === workOrder?.id) {
      // moved WO is moved before its original position, use original travel time

      movedWorkOrderTravelTime.next = workOrder?.travelNext ?? 0;
    }

    if (!prevWorkOrder) {
      // moved WO is first, add travel time from starting point

      const woCoords = stringifyCoords([workOrder]);
      const travelPreviousCoords = addStartingPointCoords(
        woCoords,
        unitStartingPoint,
        'start'
      );
      const travelTime = await getDrivingInfo(travelPreviousCoords);
      movedWorkOrderTravelTime.previous = Math.round(travelTime.duration);
    } else if (prevWorkOrder?.id === workOrder?.id) {
      // moved WO is moved after its original position, use original travel time

      movedWorkOrderTravelTime.previous = workOrder?.travelPrevious ?? 0;
    } else {
      //there is a valid previous work order, get drriving info

      const coordsPrevious = stringifyCoords([prevWorkOrder, workOrder]);
      const travelTime = await getDrivingInfo(coordsPrevious);
      movedWorkOrderTravelTime.previous = Math.round(travelTime.duration);
    }

    await updateTravelTime(workOrder.id, {
      travelNext: movedWorkOrderTravelTime.next,
      travelPrevious: movedWorkOrderTravelTime.previous,
    }).json();

    await updateEdgeWorkOrdersTravelTime({
      workOrder,
      nextWorkOrder,
      prevWorkOrder,
    });
    return { ok: true };
  } catch (error) {
    console.log(error);

    const errorMsg = errorCodes[(error as { code: string })?.code ?? 'DEFAULT'];

    return {
      ok: false,
      error: errorMsg,
    };
  }
}

const errorCodes: { [key: string]: string } = {
  PAST_TIME:
    'Nepodarilo sa posunúť pracovný príkaz: nový čas začiatku PP nesmie byť v minulosti.',
  DEFAULT: `Nepodarilo sa posunúť pracovný príkaz.`,
};
